"use strict";

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
* TODO - this should be a general react component
*/

var _ref = _jsx("input", {
    type: "hidden",
    id: "csv_import_csrf_token",
    name: "csrf_token",
    value: "82550f865092905cd14c6c4a7da37758"
});

module.exports = _react2["default"].createClass({
    displayName: "exports",


    /**
     */

    getInitialState: function getInitialState() {
        return {
            app: this.props.app || window.app
        };
    },

    /**
    */

    handleFile: function handleFile(event) {

        var self = this;
        var reader = new FileReader();
        var file = event.target.files[0];

        /*reader.onload = function(upload) {
        self.setState({
        data_uri: upload.target.result
        });
        }
         reader.readAsDataURL(file);*/

        if (this.props.onFile) {
            this.props.onFile(this.state.app.models.File({
                name: file.name,
                _form: this.refs.uploadForm
            }));
        }
    },

    /**
    */

    render: function render() {
        return _react2["default"].createElement(
            "form",
            { ref: "uploadForm", className: "csv_import", method: "POST", action: "/webapp_dev.php/home/csvFileImport", enctype: "multipart/form-data" },
            _jsx("span", {
                id: "csv_import_link"
            }, void 0, "Import CSV"),
            _jsx("input", {
                type: "file",
                name: "csv_file",
                id: "csv_import_file_select",
                onChange: this.handleFile,
                style: { style: "block" }
            }),
            _ref
        );
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/app/content/team/upload-csv-button.jsx
 ** module id = 720
 ** module chunks = 0
 **/